import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ClientImportAlertsState {
  /** Null until first loaded: no badge rather than a misleading 0. */
  pendingCount: number | null;
}

export const initialState: ClientImportAlertsState = { pendingCount: null };

/** Client-import alerts slice (#748): the count behind the "Collection" badge. */
const slice = createSlice({
  name: 'clientImportAlerts',
  initialState,
  reducers: {
    pendingCountLoaded: (state, action: PayloadAction<number>) => {
      state.pendingCount = action.payload;
    },
  },
});

export const clientImportAlertsActions = slice.actions;
export const clientImportAlertsReducer = slice.reducer;
